<template>
  <v-container>
    <div
      v-for="(listbodypart, index) in model.evaluationsBodyElement"
      :key="index"
    >
      <v-row dense>
        <v-col cols="12" sm="12" md="12" lg="12">
          <h3 align="center">
            <v-banner
              color="blue-grey lighten-5"
              class="br black--text"
              shaped
              single-line
              align="center"
            >
              <strong>{{ listbodypart.bodyPart.name }}:</strong>
              <br />
            </v-banner>
          </h3>
        </v-col>
        <v-col
          v-for="(listelements, index) in listbodypart.bodyElements"
          :key="index"
          @click.right.prevent
          @copy.prevent
          @paste.prevent
          ondrop="return false;"
        >
          <validation-provider
            v-slot="{ errors, touched, invalid }"
            :name="listelements.bodyElement.name"
            rules="required|max:200"
          >
            <v-text-field
              :label="listelements.bodyElement.name"
              v-model="listelements.note"
              :error-messages="errors"
              required
              :clear-icon="$cnst.CLEAR_ICON"
              clearable
              :disabled="isViewDetailsForm"
              :counter="200"
              ><v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                {{ touched && invalid ? "mdi-alert" : "" }}
              </v-icon>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
  },
  components: {
    ValidationProvider,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
